import { Context } from "../../Reducers/Store";
import React, { useContext } from "react";

function Loading() {
  const [state] = useContext(Context);

  return (
    <>
      {state.loading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/55 backdrop-blur-[1px]">
          <svg className="h-10 w-10 animate-spin text-white" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-90" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
      )}
    </>
  );
}

export default Loading;
